import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DialogModule } from 'primeng/dialog';
import { InputText } from 'primeng/inputtext';
import * as SmartyStreetsSDK from 'smartystreets-javascript-sdk';

@Component({
  selector: 'app-order-address',
  imports: [CommonModule, AutoCompleteModule, FormsModule, InputText, ReactiveFormsModule, DialogModule],
  templateUrl: './address.component.html',
  styleUrl: './address.component.scss',
  standalone:true,
  encapsulation:ViewEncapsulation.None
})
export class OrderAddressComponent  implements OnInit {
  formData!: FormGroup;
  visible: boolean = false;
  addressOptions = <any>[];

  async addressSelected(event: any) {
    console.log("Setting form", event.value);
    this.formData.controls["line1"].setValue(event.value.streetLine);
    this.formData.controls["town"].setValue(event.value.city);
    this.formData.controls["state"].setValue(event.value.state);
    this.formData.controls["postal_code"].setValue(event.value.zipcode);

      const SmartyStreetsCore = SmartyStreetsSDK.core;
      const websiteKey = "112622355404515731"; // Your Website Key
      const Lookup = SmartyStreetsSDK.usStreet.Lookup;
      const credentials = new SmartyStreetsCore.SharedCredentials(websiteKey);
      const clientBuilder = new SmartyStreetsCore.ClientBuilder(credentials);
      const client = clientBuilder.buildUsStreetApiClient();
      const lookup = new Lookup(
        event.value.streetLine,
        undefined,
        undefined,
        event.value.city,
        event.value.state,
        event.value.zipcode
      );
      const result = await client.send(lookup);
      console.log("SMARTY STREET", result.lookups[0].result[0].metadata);
     const results = result.lookups as any[];
     if (results.length > 0)
     {
      this.formData.controls["latitude"].setValue(results[0].result[0].metadata.latitude);
      this.formData.controls["longitude"].setValue(results[0].result[0].metadata.longitude);
       }

    this.formData.updateValueAndValidity();
    console.log("Updated form", this.formData);
  }

  showDialog() {
      this.visible = true;
  }
  constructor(public fb:FormBuilder,private router:Router) {}

  async searchAddress(event: any) {
    console.log(event);
    const SmartyStreetsCore = SmartyStreetsSDK.core;
    const websiteKey = "112622355404515731"; // Your Website Key
    const Lookup = SmartyStreetsSDK.usAutocompletePro.Lookup;
    const credentials = new SmartyStreetsCore.SharedCredentials(websiteKey);
    const clientBuilder = new SmartyStreetsCore.ClientBuilder(credentials);
    const client = clientBuilder.buildUsAutocompleteProClient();
    const lookup = new Lookup(event.query);
    lookup.maxResults = 10;
    const result = await client.send(lookup);
    console.log("Smarty", result);
    this.addressOptions = result.result as any[];
  }
  
  ngOnInit() {
    this.formData = this.fb.group({
      line1: ['', Validators.required],
      town: ['', Validators.required],
      state: [null, Validators.required],
      latitude: [''],
      longitude: [''],
      postal_code: ['', [Validators.required, Validators.pattern('^[0-9]{5}$')]],
    });
  }
  submitForm() {
    console.log('Form Submitted:', this.formData);
  }
  handleRoute() {
    this.router.navigate(['/orders/internet-plan']);
    this.visible=false;
  }
}
